import { useTranslation } from "react-i18next"
import CommonUtil from "../../../utils/CommonUtil"
import { useEffect } from "react"

const AddDevice = props => {
    const { t } = useTranslation()

    const postTitle = () => {
        if (CommonUtil.isInApp(navigator.userAgent)) {
            window.ReactNativeWebView.postMessage(t('how_add_device'))
        }
    }

    useEffect(() => {
        postTitle()
    }, [])
    return <div className="App">
        <div className="bind-device-faq">
            <span style={{ fontSize: 16, fontWeight: '500', color: '#000000', marginLeft: 25, marginTop: 15 }}>{t('how_add_device')}</span>
            <div className="bind-device-faq-marginH25">
                <span style={{ fontSize: 14, color: '#666666', marginTop: 10, whiteSpace: 'pre-line', lineHeight: '22px' }}>{t('add_device_step1_detail')}</span>
            </div>
            <span style={{ fontSize: 16, fontWeight: '500', color: '#000000', marginLeft: 25, marginTop: 30 }}>{t('add_device_step2')}</span>
            <div className="bind-device-faq-marginH25">
                <span style={{ fontSize: 14, color: '#666666', marginTop: 10, whiteSpace: 'pre-line', lineHeight: '22px' }}>{t('add_device_step2_detail')}</span>
            </div>
            <span style={{ fontSize: 16, fontWeight: '500', color: '#000000', marginLeft: 25, marginTop: 30 }}>{t('add_device_step3')}</span>
            <div className="bind-device-faq-marginH25">
                <span style={{ fontSize: 14, color: '#666666', marginTop: 10, whiteSpace: 'pre-line', lineHeight: '22px' }}>{t('add_device_step3_detail1')}</span>
            </div>
            <div className="bind-device-faq-marginH20">
                <img src={`${CommonUtil.getSourceDomain()}bind_faq_step2.png`} alt="" style={{ width: '100%', marginLeft: 20, marginTop: 15 }} />
            </div>
            <div className="bind-device-faq-marginH25">
                <span style={{ fontSize: 14, color: '#666666', marginTop: 10, whiteSpace: 'pre-line', lineHeight: '22px' }}>{t('add_device_step3_detail2')}</span>
            </div>
            <div className="bind-device-faq-marginH20">
                <img src={`${CommonUtil.getSourceDomain()}add_device_in_setting.png`} alt="" style={{ width: '100%', marginLeft: 20, marginTop: 15 }} />
            </div>
            <div style={{ height: 40 }} />
        </div>
    </div>
}

export default AddDevice